module.exports = ".checkboxes label {\n\tmin-width: 60%;\n\tmargin-bottom: 9px;\n\tpadding-bottom: 12px;\n\tpadding-left: 4px;\n\tborder-bottom: 1px solid #7f7f7f61;\n}\n\nh2 {\n  font-size: 18px;\n  margin-bottom: 28px;\n  color: #272727;\n  font-weight: 100;\n}\n\n.actions {\n  float: right;\n  margin-top: 15px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/flights/bulk-edit/bulk-edit.component.css
// module id = ./src/app/flights/bulk-edit/bulk-edit.component.css
// module chunks = main